import { createSlice } from '@reduxjs/toolkit';

import type { BannerAssets } from '@/types';

export interface BannersState {
  banners: BannerAssets;
}

const initialState: BannersState = {
  banners: {
    assets: [],
  },
};

export const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    setBanners: (state, { payload }) => {
      state.banners = payload;
    },
  },
});

export const {
  reducer: bannerReducer,
  actions: { setBanners },
} = bannerSlice;
